module.exports = __webpack_public_path__ + "media/rondeau_des_fleurs.28f40283.mp3";